var React = require('react');

function PencilInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 12.08V14.9971H2.91707L11.5244 6.38976L8.60731 3.47269L0 12.08ZM13.7725 4.14167C14.0758 3.8383 14.0758 3.34434 13.7725 3.04096L11.9561 1.2246C11.6527 0.921226 11.1588 0.921226 10.8554 1.2246L9.43187 2.64813L12.3489 5.5652L13.7725 4.14167Z","fill":"currentColor"}));
}

PencilInline.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = PencilInline;

PencilInline.default = PencilInline;
